(function () {

    angular
    .module('ngmvac')
    .filter('FacilitiesRoomDetailsFilter', FacilitiesRoomDetailsFilter);

    function FacilitiesRoomDetailsFilter() {


        return function(facilities) {
            if (typeof facilities === 'undefined') {
                return [];
            }

            var facilitiesRes = [];
            angular.forEach(facilities, function (facility) {
                if (facility.facilityCode == 261 && facility.facilityGroupCode == 60) {
                    if (facilitiesRes.length <= 2) {
                        facilitiesRes.push(facility);
                    } else {
                        facilitiesRes.splice(0, 1, facility);
                    }
                    
                } 

                if (facility.facilityCode == 100 && facility.facilityGroupCode == 60 && facilitiesRes.length <= 2) {
                    facilitiesRes.push(facility);
                }

                if (facility.facilityCode == 180 && facility.facilityGroupCode == 60 && facilitiesRes.length <= 2) {
                    facilitiesRes.push(facility);
                }

                if (facility.facilityCode == 263 && facility.facilityGroupCode == 60 && facilitiesRes.length <= 2) {
                    facilitiesRes.push(facility);
                }

                if (facility.facilityCode == 269 && facility.facilityGroupCode == 60 && facilitiesRes.length <= 2) {
                    facilitiesRes.push(facility);
                }

                if (facility.facilityCode == 170 && facility.facilityGroupCode == 60 && facilitiesRes.length <= 2) {
                    facilitiesRes.push(facility);
                }
            });

            if (facilitiesRes.length == 0) {
                var limit = (facilities.length > 2) ? 2 : facilities.length;
                facilitiesRes = facilities.slice(0, limit);
            }

            return facilitiesRes;
        };
    }

})();
